import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AlertDefinitionCategory } from '../../Models/Domains/Threads/AlertDefinitionCategory';

declare var IS_RUNNING_IN_APP_POOL;

export class NotificationDefinitionCategoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<AlertDefinitionCategory>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/NotificationDefinitionCategory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<AlertDefinitionCategory>, any>(url, data);
  }
}

